import { useMemo, useCallback } from 'react';
import { useMerchants } from './use-merchants';

/**
 * Globaler Merchant-Lookup: merchantId → merchantName.
 * Cached ueber React Query (5min staleTime aus useMerchants).
 */
export function useMerchantMap() {
  const { data } = useMerchants({ limit: 200 });

  const merchantMap = useMemo(() => {
    const m = new Map<string, string>();
    data?.data.forEach((merchant) => m.set(merchant.merchantId, merchant.name));
    return m;
  }, [data]);

  const resolveMerchantName = useCallback(
    (id: string) => merchantMap.get(id) ?? id,
    [merchantMap],
  );

  return {
    merchantMap,
    resolveMerchantName,
    merchants: data?.data ?? [],
  };
}
